/**
 * Creates an array split into two groups determined by a predicate function
 * @param arr
 * @param predicateFn
 * @returns two arrays, first where all elems === true in selector function
 */
export function partitionArray(arr, predicateFn) {
    const a = [];
    const b = [];

    for (const elem of arr) {
        if (predicateFn(elem)) {
            a.push(elem);
        } else {
            b.push(elem);
        }
    }

    return [a, b];
}
